import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "10",
  cy: "8",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "14",
  cy: "8",
  r: "1"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "6",
  r: "1"
}, "3"), /*#__PURE__*/_jsx("path", {
  d: "M16 17H8c-.55 0-1 .45-1 1s.45 1 1 1h1c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h1c.55 0 1-.45 1-1s-.45-1-1-1z"
}, "4")], 'SportsGolfRounded');